import React from 'react'
import useRescuerUploads from 'hooks/useRescuerUploads'
import moment from 'moment'
import './RescuerUploadsTab.css'

export default function RescuerUploadsTab({username}) {
    const {data: uploads, isLoading, error} = useRescuerUploads(username)

    if (isLoading) return <div id="spinner" className="center"/>
    if (error) return <div className="alert alert-danger">Greška pri učitavanju</div>
    if (!uploads || uploads.length === 0) {
        return <div className="text-muted">Nema profilnih slika</div>
    }

    const getStatusBadge = (status) => {
        if (status === 'approved') return <span className="status-badge status-approved">Odobreno</span>
        if (status === 'rejected') return <span className="status-badge status-rejected">Odbijeno</span>
        return <span className="status-badge status-pending">Na čekanju</span>
    }

    const handleView = (upload) => {
        window.open(upload.url, '_blank')
    }

    const handleDownload = (e, upload) => {
        e.stopPropagation()
        window.open(upload.download_url || upload.url, '_blank')
    }

    return (
        <div id="rescuer-uploads">
            <div className="uploads-grid">
                {uploads.map(upload => (
                    <div key={upload.id} className="upload-box" onClick={() => handleView(upload)}>
                        <img src={upload.url} alt={upload.filename} />
                        <div className="upload-overlay">
                            <div className="upload-info">
                                <div className="upload-filename" title={upload.filename}>
                                    {upload.filename || 'Untitled'}
                                </div>
                                <div className="upload-meta">
                                    {moment(upload.created).format('DD.MM.YYYY HH:mm')}
                                </div>
                                <div className="upload-status">
                                    {getStatusBadge(upload.status)}
                                </div>
                                {upload.comment && (
                                    <div className="upload-comment">{upload.comment}</div>
                                )}
                            </div>
                            <button className="download-icon" onClick={(e) => handleDownload(e, upload)} title="Preuzmi">
                                <i className="fas fa-download"/>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
